<template>
  <div style="height: 100%">
    <div class="headers_box flex flex_items_center">
      <el-menu
        @select="handleSelect"
        :text-color="'#44435A'"
        :active-text-color="'#1D2379'"
        :default-active="activeIndex"
        collapse-transition
        class="el-menu-middle moblie-menu"
        mode="horizontal"
        menu-trigger="hover"
        ref="kzMenu"
      >
        <template v-for="(item, index) in visibleItems">
          <!-- 有子菜单 -->
          <el-submenu
            popper-class="test"
            v-if="item.children"
            :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
            :key="index"
            :show-timeout="100"
            :popper-append-to-body="false"
          >
            <template slot="title">
              <span>{{ langSet == "cn" ? item.name_cn : item.name_en }}</span>
            </template>

            <template v-for="(n, i) in item.children">
              <el-menu-item
                v-if="
                  (n.name_cn.length > 0 && langSet == 'cn') ||
                  (n.name_en.length > 0 && langSet == 'en')
                "
                :key="i"
                :index="
                  langSet == 'cn'
                    ? n.http_url_cn !== '/download'
                      ? n.http_url_cn
                      : n.http_url_cn + '/' + n.id
                    : n.http_url_en !== '/download'
                    ? n.http_url_en
                    : n.http_url_en + '/' + n.id
                "
              >
                <template>
                  <span slot="title">{{
                    langSet == "cn" ? n.name_cn : n.name_en
                  }}</span>
                </template>
              </el-menu-item>
            </template>
          </el-submenu>
          <!-- 没有子菜单 -->
          <el-menu-item
            v-else
            :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
            :key="index"
          >
            <span slot="title">{{
              langSet == "cn" ? item.name_cn : item.name_en
            }}</span>
          </el-menu-item>
        </template>
        <!-- 折叠菜单触发按钮 -->
        <el-popover
          v-if="hiddenItems.length > 0"
          placement="bottom"
          trigger="click"
          popper-class="hidden-menu-popper"
        >
          <template #reference>
            <el-button class="more-btn">···</el-button>
          </template>
          <el-menu @select="handleSelect">
            <el-menu-item
              v-for="(item, index) in hiddenItems"
              :key="index"
              :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
            >
              {{ langSet == "cn" ? item.name_cn : item.name_en }}
            </el-menu-item>
          </el-menu>
        </el-popover>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { webMenu } from "@/api/api";
import de from "element-ui/src/locale/lang/de";
import { sdkClick } from "../sdk/useSdk";

export default {
  data() {
    return {
      menuArr: [],
      user: require("../assets/user.png"),
      langSet: "",
      visibleItems: [],
      hiddenItems: [],
      currentWidth: 0,
    };
  },
  created() {
    localStorage.getItem("languageSet");
  },
  mounted() {
    this.langSet = this.$language;
    this.getMenu();
    window.addEventListener("resize", this.calculateMaxVisible);
  },
  computed: {
    activeIndex() {
      const { name, fullPath, meta } = this.$route;
      let rout = "";
      if (meta.parent) {
        rout = meta.parent;
      } else {
        rout = this.$route.fullPath;
      }
      return rout;
    },
  },
  methods: {
    startsWithSlash(str) {
      return /^\//.test(str);
    },
    isPDF(fileName) {
      if (!fileName) return false;
      // 获取后缀
      const suffix = fileName.split(".").pop().toLowerCase();
      // PDF后缀列表
      const pdfExtensions = ["pdf"];
      return pdfExtensions.includes(suffix);
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      if(key.length == '1'){
        this.$message.warning(this.langSet == "cn" ? '敬请期待' : 'Coming Soon');
        return false;
      }
      this.handleTrackingPoint(keyPath);
      if (key) {
        if (this.startsWithSlash(key)) {
          this.$router.push({
            path: key,
          });
        } else {
          if (key == 0) {
            this.$emit("changjqqd");
          } else {
            let path = key;
            window.open(path, "_blank");
          }
        }
      }
    },
    getMenu() {
      let arr = [];
      let data = {
        page_type: 0,
      };
      webMenu(data)
        .then((res) => {
          if (res.code == 1) {
            let lists = res.data.lists;
            localStorage.setItem("menuArr", JSON.stringify(lists));
            lists.map((item, index) => {
              if (item.is_top == "是") {
                arr.push(item);
              }
            });
            this.menuArr = arr;
            this.calculateMaxVisible();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toLink(path) {
      this.$router.push({
        path,
      });
    },
    calculateMaxVisible() {
      const containerWidth = this.$el.offsetWidth;
      if (containerWidth < 750) {
        const itemWidth = 98; // 根据实际菜单项宽度调整
        const maxVisible = Math.floor((containerWidth - 30) / itemWidth); // 60为更多按钮预留空间
        this.visibleItems = this.menuArr.slice(0, maxVisible);
        this.hiddenItems = this.menuArr.slice(maxVisible);
      } else {
        this.visibleItems = this.menuArr;
        this.hiddenItems = [];
      }
    },
    handleTrackingPoint(keyPath) {
      let menuArray = this.menuArr;
      let resultArray = [];
      menuArray.forEach((v) => {
        if (v.http_url_cn === keyPath[0]) {
          resultArray.push(v.name_cn);
          if (keyPath.length > 1) {
            v.children.forEach((v2) => {
              if (v2.http_url_cn === keyPath[1]) {
                resultArray.push(v2.name_cn);
              }
            });
          }
        }
      });
      if (resultArray.length === 1) {
        sdkClick("导航菜单栏", resultArray[0]);
      } else {
        sdkClick("导航菜单栏", resultArray[0] + ">>" + resultArray[1]);
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateVisibility);
  },
};
</script>

<style lang="scss" scoped>
.el-dialog {
  z-index: 3000 !important;
}
.headers_box {
  height: 100%;
  position: relative;
  .more-btn {
    border: 0 none;
    font-size: 18px;
    color: #1d2379;
    margin: 0 10px;
  }
}
.headers_slide_box {
  height: 100%;
}
.dialog {
  width: 200000px;
  height: 288px;
  background: #ffffff;
  border-radius: 12px;
  margin: auto;
  display: flex;
}
.dialog_img {
  width: 500px;
  height: 160px;
}
.dialog_txt {
  margin-top: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.el-menu {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  // justify-content: space-around;
  box-sizing: border-box;
  background: transparent !important;
}
.el-menu-item {
  font-size: 16px;
  height: 100%;
  line-height: 25px;
  min-width: 98px;
  text-align: center;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .el-submenu__title {
  font-size: 16px;
  padding: 0 0 !important;
}
.el-submenu__title * {
  vertical-align: initial;
  white-space: break-spaces;
}
/deep/ .el-submenu__title i {
  display: none;
}
.el-menu.el-menu--horizontal,
.el-menu--horizontal > .el-menu-item {
  border-bottom: 0 none;
  background: transparent !important;
}
.headers_box .el-menu--horizontal > .el-menu-item:hover,
.headers_slide_box .el-menu--horizontal > .el-menu-item:hover {
  color: #1d2379 !important;
}
.headers_box .el-menu--horizontal > .el-menu-item.is-active {
  color: #fff;
  border: 0 none;
}
.headers_slide_box .el-menu--horizontal > .el-menu-item.is-active {
  color: #2c2c2e;
}
.el-menu-middle .el-menu-item,
.el-menu-middle .el-submenu__title {
  white-space: normal;
}
/deep/ .headers_box .el-menu--horizontal > .el-menu-item.is-active span {
  min-height: 36px;
  padding: 7px 17px;
  line-height: 20px;
  box-sizing: border-box;
  background: rgba(29, 35, 121, 0.1);
  border-radius: 30px;
}
/deep/ .el-menu--horizontal > .is-active .el-submenu__title span {
  min-height: 36px;
  padding: 7px 17px;
  line-height: 20px;
  box-sizing: border-box;
  background: rgba(29, 35, 121, 0.1);
  border-radius: 30px;
}
@media only screen and (max-width: 1450px) {
}
@media only screen and (max-width: 767px) {
  .el-menu {
    position: absolute;
    width: 100%;
  }
}
/deep/ .headers_box .el-menu--horizontal > .el-menu-item.is-active {
  border-radius: 18px;
}
</style>
<style>
.el-submenu {
  /* width: 140px; */
  min-width: 98px;
  display: flex;
  justify-content: center;
  position: relative;
  /* text-align: center; */
  /* padding-right: 22px; */
}
.headers_box .el-menu--horizontal > .el-menu-item {
  line-height: 20px;
}
.headers_box .el-menu--horizontal > .el-submenu .el-submenu__title {
  display: flex;
  align-items: center;
  line-height: 20px;
  justify-content: center;
  text-align: center;
  background: transparent !important;
}
.headers_box .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: #fff;
  border-bottom: 0 none;
}
.headers_box .el-menu--horizontal > .el-submenu .el-submenu__title:hover,
.headers_box .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: #1d2379 !important;
}

.headers_slide_box .el-menu--horizontal > .el-submenu .el-submenu__title {
  display: flex;
  align-items: center;
  line-height: 25px;
  background: transparent !important;
}
.headers_slide_box
  .el-menu--horizontal
  > .el-submenu.is-active
  .el-submenu__title {
  color: #fff;
  border-bottom: 0 none;
}
.test {
  position: absolute !important;
  top: 55px !important;
  left: 0 !important;
  border: none !important;
}
/* 弹出的二级菜单 */
.test .el-menu--popup {
  width: 140px;
  min-width: auto;
  position: relative;
  left: -20px;
  margin: 0;
  padding: 5px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0px 5px 20px 0px rgba(0, 26, 51, 0.16);
}
/* 修改二级菜单整个背景颜色 */
.test .el-menu {
  background: #ffffff;
  /* box-shadow: 0px 0px 4px 0px rgba(255, 255, 255, 0.12); */
  border-radius: 12px;
  backdrop-filter: blur(4px);
}
/* 二级菜单中的子选项 */
.test .el-menu .el-menu-item {
  /* background-color: transparent !important; */
  /* color: rgba(255, 255, 255, 0.7) !important; */
  font-weight: 400;
  width: auto;
  min-width: auto;
  min-height: 38px !important;
  height: auto !important;
  padding: 9px 0 !important;
  font-weight: 500;
  line-height: 15px !important;
  white-space: initial;
  font-size: 14px;
  justify-content: center;
}
/* 被选择的子选项 */
.test .el-menu .el-menu-item:not(.is-disabled):hover {
  color: #1d2379 !important;
  background: rgba(29, 35, 121, 0.1);
  border-radius: 8px;
  width: 100%;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background-color: rgb(44, 44, 46);
  border-bottom-color: #2c2c2c !important;
}
.hidden-menu-popper {
  width: 140px;
  min-width: 140px !important;
  border-radius: 20px !important;
}
.hidden-menu-popper .el-menu {
  display: block;
  border: 0 none;
}
.hidden-menu-popper .el-menu .el-menu-item {
  height: 38px;
  line-height: 38px;
  font-size: 14px;
  color: #000;
  border-radius: 8px;
  padding-left: 0 !important;
}
.hidden-menu-popper .popper__arrow {
  display: none !important;
}
</style>